import {
    RaikoBaseCardContainer,
    RaikoGridTwoColumn,
    RaikoNumberInputOutlined,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function GameStageSetting({gameStageId}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    const [scoreWeight, setScoreWeight] = useState(0);
    const [maxScore, setMaxScore] = useState(0);

    const service = new GameStageService();
    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameStageSettingFromServer()
        }
    }, [gameStageId]);

    function getGameStageSettingFromServer() {
        loading.show()
        service.getGameStageSettings(gameStageId)
            .then(response => {
                setScoreWeight(response.scoreWeight)
                setMaxScore(response.maxScore)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleUpdateGameStageSetting() {
        setActionButtonLoading(true)
        service.updateGameStageSettings(gameStageId, scoreWeight, maxScore)
            .then(response => {
                showSuccessMessage("تنظیمات با موفقیت بروزرسانی شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"تنظیمات"}
                hasActionButton
                actionButtonLoadingState={actionButtonLoading}
                actionButtonOnclickWithValidation={handleUpdateGameStageSetting}
            >
                <RaikoGridTwoColumn>
                    <RaikoNumberInputOutlined
                        labelText={"وزن امتیاز"}
                        value={scoreWeight}
                        setValue={setScoreWeight}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"حداکثر امتیاز"}
                        value={maxScore}
                        setValue={setMaxScore}
                        required
                    />
                </RaikoGridTwoColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}